// Virtuele iPad (0028, module virtual_device; docs/DESIGN.md §8.VI; verzoek oprichter 2026-09-25:
// "precies ervaren hoe het is ... alsof ik een echte ipad zou hebben"). Het echte bord in een
// iPad-lijst in de ouderapp, alleen voor ouders. Sleutels in `a.virtualDevice.*` (app.nl.ts).
// Toon: je-vorm, korte zinnen, werkwoorden op knoppen.
export const appVirtualDeviceNl = {
    title: 'Virtuele iPad',
    intro: 'Het echte gezinsbord, precies zoals op de tablet aan de muur.',
    /** Ingang op Tablets en Instellingen. */
    entry: 'Virtuele iPad',
    entryBody: 'Het bord in je browser, om te kijken en te proberen.',
    // ---- Werkbalk --------------------------------------------------------------------------------
    orientation: 'Stand',
    landscape: 'Liggend',
    portrait: 'Staand',
    zoom: 'Grootte',
    fit: 'Passend',
    actual: '100%',
    profile: 'Tablet van',
    /** Kamer met alle gezinsleden. */
    roomEveryone: '{room}, iedereen',
    /** Kamer met eigen bewoners: "Kamer Noor, Noor". */
    roomMembers: '{room}, {names}',
    ownWindow: 'Eigen venster',
    ownWindowLabel: 'Open de virtuele iPad in een eigen venster van 1024 bij 768',
    // ---- Koppelen --------------------------------------------------------------------------------
    pairTitle: 'Koppel deze virtuele iPad',
    pairBody: 'Hij wordt een eigen tablet in je gezin. Je vindt hem daarna bij Tablets en kunt hem daar loskoppelen.',
    pairButton: 'Koppelen',
    pairWaiting: 'Het bord maakt een koppelcode…',
    pairedToast: 'Virtuele iPad gekoppeld',
    status: '{name} in {room}',
    moved: 'Het bord toont nu de tablet van {room}',
    revoke: 'Loskoppelen',
    revokeTitle: 'Virtuele iPad loskoppelen?',
    revokeBody: 'Het bord in je browser toont daarna weer een koppelcode. Je echte tablets merken hier niets van.',
    revoked: 'Virtuele iPad losgekoppeld',
    // ---- Uitleg en fouten ------------------------------------------------------------------------
    hint: 'Elke klik is een tik. Geluid en voorlezen werken na je eerste klik op het bord, net als op de iPad.',
    storageTitle: 'Deze browser houdt de koppeling niet vast in de pagina',
    storageBody: 'Sommige browsers (vaak Safari) bewaren een ingebed bord apart. Open de iPad in een eigen venster: daar blijft hij gekoppeld.',
    popupBlocked: 'Je browser hield het venster tegen. Sta pop-ups toe voor deze site en probeer het opnieuw.',
    frameTitle: 'Gezinsbord op de virtuele iPad',
    // ---- Al gekoppeld als gewone tablet (bord eerder direct geopend in deze browser) ---------------
    foreignTitle: 'Dit bord is gekoppeld als {name}, een gewone tablet',
    foreignBody: 'Je opende het bord eerder direct in deze browser. Koppel het opnieuw als virtuele iPad: {name} wordt dan losgekoppeld.',
    foreignButton: 'Opnieuw koppelen als virtuele iPad',
    foreignOtherTitle: 'Dit bord hoort bij een ander gezin',
    foreignOtherBody: 'Deze browser is als tablet van een ander gezin gekoppeld. Koppel hem daar los bij Tablets, of open deze pagina in een privévenster.',
    foreignStatus: '{name} in {room} (gewone tablet)',
    // ---- Bord meldt zich niet --------------------------------------------------------------------
    stuckTitle: 'Het bord meldt zich niet',
    stuckBody: 'Laad het bord opnieuw. Blijft het leeg, open het dan in een eigen venster.',
    stuckReload: 'Opnieuw laden',
    /** Label op de kaart in Tablets. */
    tag: 'Virtueel',
    openOnDevice: 'Openen',
};
//# sourceMappingURL=virtualDevice.nl.js.map